function getUsers () {
  const users = [{
    value: "region_0",
    label: "小明"
  }, {
    value: "region_1",
    label: "小明1"
  }, {
    value: "region_2",
    label: "小明2"
  }, {
    value: "region_3",
    label: "小明3"
  }, {
    value: "region_4",
    label: "小明4"
  }, {
    value: "region_5",
    label: "小明5"
  }
  ];
  return users;
}
module.exports = {
  getUsers
};



// WEBPACK FOOTER //
// ./src/data/demoUser.js